import { Dispatch, SetStateAction } from "react";
import Modal from "../Shared/Modal";
import { X } from "lucide-react";
import CloseIcon from "../Icons/CloseIcon";

type ModalProps = {
    isOpen: boolean;
    closeModal: Dispatch<SetStateAction<boolean>>;
};

const PaymentFailedModal = ({ isOpen, closeModal }: ModalProps) => {
    return (
        <Modal
            className={"!max-w-[1246px]"}
            isOpen={isOpen}
            closeModal={closeModal}
        >
            <div className="py-4 px-2 relative border-b-red-500 border-b-[8px]">
                <button
                    onClick={() => {
                        closeModal(false);
                    }}
                    className="absolute top-3 right-4 md:right-9"
                >
                    <CloseIcon/>
                    </button>
                <div className="flex flex-col items-center  justify-center px-4 md:px-6 py-12 md:py-24 lg:py-32">
                    <div className="max-w-md text-center space-y-4 ">
                        <div className="bg-red-100 dark:bg-red-900 rounded-full p-4 inline-flex">
                            <X className="h-8 w-8 text-red-500 dark:text-red-400" />
                        </div>
                        <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl">Payment Failed</h1>
                        <p className="text-gray-500 dark:text-gray-400 md:text-xl">
                        We tried to charge your card but, something went wrong. Please update your payment method and try again later
                        </p>
                        <p className="mt-2 text-center text-sm text-gray-600 dark:text-gray-400">Thanks for your effort.</p>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default PaymentFailedModal;
